import React from 'react';
import PropTypes from 'prop-types';

import {
  DropdownSimple,
} from '@resy/ui-kitchen';

class PaymentMethodDropdown extends React.Component {
  static propTypes = {
    disabled: PropTypes.bool,
    // for analytics when user clicks on dropdown
    onClick: PropTypes.func,
    onPaymentMethodSelect: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number,
    })),
    bookOnBehalfOf: PropTypes.bool,
    selectedPaymentMethod: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }

  static defaultProps = {
    disabled: false,
    onClick: () => {},
    options: [
      {
        label: 'Add new card',
        value: -1,
      },
    ],
    bookOnBehalfOf: false,
    selectedPaymentMethod: -1,
  }

  ADD_NEW_CARD = '-1'

  formatOptions = (options) => (
    options.map((option) => ({
      ...option,
      key: `${option.value}`,
      value: `${option.value}`,
    }))
  )

  render() {
    const {
      bookOnBehalfOf, disabled, onClick, onPaymentMethodSelect, options, selectedPaymentMethod,
    } = this.props;

    const disabledDropDown = disabled || bookOnBehalfOf || options.length === 0;

    return (
      <DropdownSimple
        disabled={disabledDropDown}
        name="payment_method"
        onClick={onClick}
        options={this.formatOptions(options)}
        onChange={onPaymentMethodSelect}
        value={selectedPaymentMethod.toString()}
      />
    );
  }
}

PaymentMethodDropdown.displayName = 'PaymentMethodDropdown';
export default PaymentMethodDropdown;
